/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.querySelectorAll('iframe').forEach((iframe) => this.#formatVideoEmbed(iframe));
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  /**
   * Wraps YouTube/Vimeo iframes so they can be sized to the RTE column at 16:9
   * @param {HTMLIFrameElement} iframe
   */
  #formatVideoEmbed(iframe) {
    if (iframe.closest('deferred-media, .rte-video-wrapper, .video-wrapper')) return;
    if (!this.#isVideoEmbed(iframe)) return;

    const parent = iframe.parentElement;
    if (!parent) return;

    const onlyEmbed = [...parent.childNodes].every((node) => {
      if (node === iframe) return true;
      return node.nodeType === Node.TEXT_NODE && !node.textContent.trim();
    });

    if (onlyEmbed && parent.matches('p, div')) {
      parent.classList.add('rte-video-wrapper');
      return;
    }

    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-video-wrapper');
    parent.insertBefore(wrapper, iframe);
    wrapper.appendChild(iframe);
  }

  /**
   * @param {HTMLIFrameElement} iframe
   * @returns {boolean}
   */
  #isVideoEmbed(iframe) {
    const src = iframe.getAttribute('src') || iframe.getAttribute('data-src') || '';
    return /youtube|youtu\.be|vimeo/i.test(src);
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
